import { useTranslation } from 'react-i18next';
import { Switch } from '@/components/ui/switch';
import { Label } from '@/components/ui/label';
import SkillTooltip from './SkillTooltip';
import { useFormData } from '@/stores/formStore';
import { getEraConfig } from '@/config/era-registry';
import PulpFistIcon from './PulpFistIcon';

const PulpModeToggle: React.FC = () => {
  const { formData, setPulpMode } = useFormData();
  const { t } = useTranslation('pulp');
  const eraConfig = getEraConfig(formData.era);

  if (!eraConfig.supportsPulp) return null;

  const locked = !!eraConfig.pulpAlwaysOn;
  const checked = !!formData.pulpMode;

  return (
    <fieldset className="bg-card border min-w-80 w-full max-w-full text-base text-white font-normal mt-8 p-6 rounded-lg border-border border-solid max-md:px-5 opacity-0 animate-slide-fade-in">
      <legend className="text-white text-lg font-antiqua mb-1 px-1 flex items-center gap-2">
        <PulpFistIcon className="w-4 h-4 text-brand-green" />
        <SkillTooltip content={t('toggle.tooltip')}>
          <span className="cursor-help">{t('toggle.legend')}</span>
        </SkillTooltip>
      </legend>
      <div className="flex items-center justify-between gap-4 mt-2">
        <div className="flex-1">
          <Label htmlFor="pulp-mode-switch" className="text-white text-base cursor-pointer">
            {locked ? t('toggle.labelLocked') : t('toggle.labelOn')}
          </Label>
          <p className="text-sm text-muted-foreground mt-1">
            {t('toggle.help')}
          </p>
        </div>
        <Switch
          id="pulp-mode-switch"
          checked={checked}
          disabled={locked}
          onCheckedChange={(v) => setPulpMode(!!v)}
        />
      </div>
    </fieldset>
  );
};

export default PulpModeToggle;